export const FLIGHT_DESTINATION_FALLBACK = 'e.g. New York';
export const HOLIDAY_DESTINATION_FALLBACK = 'e.g. Maldives';
const UK_DESTINATION_PLACEHOLDER = 'e.g. Cancun';

const LOCALE_PATTERN = /^([a-z]{2})-([a-z]{2})$/i;
const PATH_LOCALE_PATTERN = /^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i;

const FLIGHT_DESTINATION_BY_LOCALE: Record<string, string> = {
	'en-CA': 'e.g. London',
	'en-BB': 'e.g. London',
	'en-EU': 'e.g. New York',
	'en-FR': 'e.g. New York',
	'en-IN': 'e.g. London',
	'en-IL': 'e.g. New York',
	'en-NL': 'e.g. New York',
	'en-NG': 'e.g. London',
	'en-SA': 'e.g. London',
	'ar-SA': 'e.g. London',
	'en-ZA': 'e.g. London',
	'en-KR': 'e.g. London',
	'ko-KR': 'e.g. London',
	'en-AE': 'e.g. London',
	'ar-AE': 'e.g. London',
	'en-GB': UK_DESTINATION_PLACEHOLDER,
	'en-US': 'e.g. London',
	'es-US': 'e.g. London'
};

interface LocaleResolutionInput {
	cookieLocale?: string;
	pathname?: string;
	browserLocales?: readonly string[];
}

const normaliseLocale = (locale?: string): string | undefined => {
	const match = locale?.trim().match(LOCALE_PATTERN);
	return match
		? `${match[1].toLowerCase()}-${match[2].toUpperCase()}`
		: undefined;
};

export const resolveDestinationLocale = ({
	cookieLocale,
	pathname,
	browserLocales = []
}: LocaleResolutionInput): string | undefined => {
	const pathLocale = pathname?.match(PATH_LOCALE_PATTERN)?.[1];
	const candidates = [cookieLocale, pathLocale, ...browserLocales];

	for (const candidate of candidates) {
		const locale = normaliseLocale(candidate);
		if (locale) return locale;
	}

	return undefined;
};

export const getDestinationPlaceholder = (
	locale: string | undefined,
	product: 'flight' | 'holiday'
): string => {
	const normalisedLocale = normaliseLocale(locale);

	if (product === 'holiday') {
		return normalisedLocale === 'en-GB'
			? UK_DESTINATION_PLACEHOLDER
			: HOLIDAY_DESTINATION_FALLBACK;
	}

	return normalisedLocale
		? (FLIGHT_DESTINATION_BY_LOCALE[normalisedLocale] ??
				FLIGHT_DESTINATION_FALLBACK)
		: FLIGHT_DESTINATION_FALLBACK;
};
